'use client';

import { useEffect, useState } from 'react';

interface Props {
  html: string;
  styles: string;
}

const SafeHTMLContent = ({ html, styles }: Props) => {
  const [content, setContent] = useState<string | null>(null);

  useEffect(() => {
    setContent(html);
  }, [html]);

  return (
    <div
      className={styles}
      dangerouslySetInnerHTML={content ? { __html: content } : undefined}
    />
  );
};

export default SafeHTMLContent;
